import { transformRTKQueryFnActionType } from '@/src/store/listeners'
import * as Sentry from '@sentry/react-native'

export const rtkqSentryEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: (action) => ({
    ...action,
    type: transformRTKQueryFnActionType(action),
  }),
})
